import { useDispatch } from "react-redux";
import useSWRMutation from "swr/mutation";

import { fetcherPost } from "../../services/fetcher";
import Logout from "../../utils/Logout";

const useRefreshToken = () => {
  const accessToken = JSON.parse(localStorage.getItem("token")) || null;
  const refreshToken = JSON.parse(localStorage.getItem("rt")) || null;
  const dispatch = useDispatch();

  const { trigger: refreshTrigger } = useSWRMutation(
    () => {
      if (!refreshToken || !accessToken) return Logout(dispatch);

      return [process.env.REACT_APP_API + "/auth/token/refresh/", accessToken];
    },
    fetcherPost,
    {
      onSuccess: (data) => {
        localStorage.setItem("token", JSON.stringify(data.access));
      },
      onError: (e) => {
        if (
          e.request.responseText === '{"Error":"Token is invalid or expired"}'
        ) {

        }
      },
    }
  );

  const fetchRefreshData = async () => {
    try {
      await refreshTrigger({ refresh: refreshToken });
    } catch (e) {}
  };

  return [fetchRefreshData];
};
export default useRefreshToken;
